











import Vue, { PropType } from 'vue'

type LogoVariants = 'square' | 'wide'

const logos: { [key in LogoVariants]: string } = {
  square: 'ic_app.png',
  wide: 'ic_app-w.png',
}

export default Vue.extend({
  name: 'Logo',
  props: {
    variant: {
      type: String as PropType<LogoVariants>,
      default: 'square',
    },
    width: {
      type: [Number, String],
      default: 54,
    },
    to: {
      type: String,
      default: '/',
    },
  },
  computed: {
    src(): string {
      return logos[this.variant as LogoVariants]
    },
  },
})
